<template>
  <div>
    <b-card title="Photos véhicules" >
      <div class="clearfix" v-if="uploadedImages.length">
        <div class="photos">
          <div v-for="image in uploadedImages" :key="image.id" class="photo mb-1 mr-1">
            <div class="position-relative">
              <b-badge v-if="image.is_primary" variant="success" class="primary-badge">Primaire</b-badge>
              <b-img  thumbnail  class="mb-1 mb-sm-0"  :src="image.path + '?w=230&h=230'"/>
            </div>
            <div class="mt-1">
              <b-button @click="delete_image(image.id)" size="sm" variant="outline-danger">Supprimer</b-button>
              <b-button v-if="!image.is_primary" @click="setPrimary(image.id)" size="sm" variant="outline-primary" class="ml-1">
                Définir comme primaire
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <b-card title="Photo Primaire (Photo-01)">
        <div v-if="primaryBase64" class="mb-1">
          <b-img width="200" thumbnail class="mb-1 mb-sm-0" :src="primaryBase64"/>
        </div>
        <b-form-file
            placeholder="Choisir la photo primaire..."
            drop-placeholder="Déposer la photo ici..."
            accept="image/*"
            @change="previewPrimary"
        />
        <b-button :disabled="!primaryBase64" @click="uploadPrimary" variant="primary" class="mt-1">
          Uploader la photo primaire
        </b-button>
      </b-card>
      <b-card title="Ajouter Photos">
        <div class="clearfix">
          <div class="photos">
            <div v-for="(image, key) in base64Images" :key="key" class="photo mb-1 mr-1">
              <div>
                <b-img width="200"  thumbnail  class="mb-1 mb-sm-0"  :src="image.image"/>
              </div>
              <b-button size="sm" class="mt-1">Supprimer</b-button>
            </div>
          </div>
        </div>
        <div>
          <b-form-file
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              multiple
              accept="image/*"
              @change="previewFiles"
          />
          <b-button :disabled="!images.length" @click="uploadFiles" variant="primary" class="mt-1">
            Uploader
          </b-button>
        </div>
      </b-card>
    </b-card>
 
  </div>

  
</template>

<script>
import axios from "@/libs/axios";

export default {
  name: "VehiculePhotosForm",
  props : {
    vehicule : {
      required : true
    }
  },
  data(){
    return {
      uploadedImages : [],
      images : [],
      previews : [],
      base64Images : [],
      primaryBase64 : null
    }
  },
  methods : {
    previewPrimary(e){
      this.primaryBase64 = null;
      let file = e.target.files[0];
      if(!file) return;
      let reader = new FileReader();
      reader.onload = () => {
        this.primaryBase64 = reader.result;
      };
      reader.readAsDataURL(file);
    },
    uploadPrimary(){
      let _this = this;
      if(!this.primaryBase64) return;
      axios.post('/api/vehicules/images-upload', {
        image : this.primaryBase64,
        vehicule_id : this.vehicule.id,
        is_primary : true
      }).then(function (response){
        _this.uploadedImages = response.data.data.images;
        _this.primaryBase64 = null;
      });
    },
    setPrimary(vehicule_image_id){
      let _this = this;
      axios.post('/api/vehicules/set-primary-image', {
        vehicule_image_id : vehicule_image_id
      }).then(function (response){
        _this.uploadedImages = response.data.data.images;
      });
    },
    uploadFiles(){
      let _this = this;
      console.log(this.base64Images);

      
      this.base64Images.forEach(function(item, index){
        console.log(item, index);
        axios.post('/api/vehicules/images-upload', {
          image : item.image,
          vehicule_id : _this.vehicule.id
        }).then(function (response){
          _this.uploadedImages = response.data.data.images;
          _this.images = [];
          _this.previews = [];
          _this.base64Images = _this.base64Images.filter(function(a, b){
            return item.index != a.index;
          })
          //_this.base64Images = [];
        });
      });
      
      return false;
      axios.post('/api/vehicules/images-upload', {
        images : this.base64Images,
        vehicule_id : this.vehicule.id
      }).then(function (response){
        _this.uploadedImages = response.data.data.images;
        _this.images = [];
        _this.previews = [];
        _this.base64Images = [];
        
      });
    },
    delete_image(vehicule_image_id){
      let _this = this;
      axios.post('/api/vehicules/remove-image', {
        vehicule_image_id : vehicule_image_id
      }).then(function(response){
        _this.uploadedImages = _this.uploadedImages.filter(function(item){
           return item.id != vehicule_image_id;
        })
      });
    },
    previewFiles(e) {
      this.previews = [];
    
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.images.push(selectedFiles[i]);
      }
      this.base64Images = [];
      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
 
          this.base64Images.push({
            image : reader.result,
            index : i
          })
 
        };
        reader.readAsDataURL(this.images[i]);
      }
    }

  },
  created() {
    this.uploadedImages = [...this.vehicule.images]
  }
}
</script>

<style scoped>
  .photo{
    float: left;

 
  }
  .photo > div{
    
  }
  .photo img{
    width: 230px;
    height: 230px;
  }
  .primary-badge{
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
  }
</style>